import { DistributiveOmit, exhaustiveCheck, keys } from '@direct-frontend/stdlib';
import { UnexpectedError } from '@adv-frontend/error';
import { BaseValidationError } from '../../types';
import { CalculatedFieldStateProperties, ObjectFieldState, UnionFieldState } from '../types';

export function extractObjectFieldStateFromUnion<FieldValue, FieldValidationError extends BaseValidationError>(
    unionFieldState: DistributiveOmit<UnionFieldState<FieldValue, FieldValidationError>, CalculatedFieldStateProperties>
): DistributiveOmit<ObjectFieldState<FieldValue, FieldValidationError>, CalculatedFieldStateProperties> {
    const {
        errorsMap,
        fields,
        initialValue,
        isTouched,
        modifiedAt,
        parentId,
        validationMeta,
        asyncActionsMeta,

        ...others
    } = unionFieldState;

    // Проверка, что в others только valuesByKey и statesByKey
    keys(others).forEach(key => {
        switch (key) {
            case 'valuesByKey':
            case 'statesByKey':
                break;
            default:
                exhaustiveCheck(
                    key,
                    new UnexpectedError('Unknown key in union field state', {
                        cause: null,
                        additional: {
                            key,
                        },
                    })
                );
        }
    });

    return {
        errorsMap,
        fields,
        initialValue,
        isTouched,
        modifiedAt,
        parentId,
        validationMeta,
        asyncActionsMeta,
    };
}
